<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00076.installation.voletimmerge.title' | translate"
      [description]="'P00076.installation.voletimmerge.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="'P00076.installation.voletimmerge.activation' | translate"
      [nameCustom]="
        'P00076.installation.voletimmerge.activation.title' | translate
      "
      [value]="actionStack!.getValue('coIActivationVoletImmerge') !== 0"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Constance_Installation,
          'coIActivationVoletImmerge',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
